import energy from "../../assets/static/images/holy-wheel/rewards/energy.png";
import beachCoin from "../../assets/static/images/holy-wheel/rewards/beach-coin.png";
import goldenSunglasses from "../../assets/static/images/holy-wheel/rewards/golden-sunglasses.png";
import goldenShirt from "../../assets/static/images/holy-wheel/rewards/golden-shirt.png";
import beachSet from "../../assets/static/images/holy-wheel/rewards/beach-set.png";
import angelSet from "../../assets/static/images/holy-wheel/rewards/angel-set.png";
import bundleSize2 from "../../assets/static/images/holy-wheel/bundle-size-indicators/2-pc.webp";
import bundleSize3 from "../../assets/static/images/holy-wheel/bundle-size-indicators/3-pc.webp";
import bundleSize4 from "../../assets/static/images/holy-wheel/bundle-size-indicators/4-pc.webp";
import bundleSize5 from "../../assets/static/images/holy-wheel/bundle-size-indicators/5-pc.webp";
import bundleSize6 from "../../assets/static/images/holy-wheel/bundle-size-indicators/6-pc.webp";
import bundleSize7 from "../../assets/static/images/holy-wheel/bundle-size-indicators/7-pc.webp";
import bundleSize8 from "../../assets/static/images/holy-wheel/bundle-size-indicators/8-pc.webp";

export type HolyWheelBundleSize = 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type HolyWheelPrize = {
    label?: string;
    imageUrl?: string;
    wheelImageUrl?: string;
    overviewImageUrl?: string;
    tagline?: string;
    description?: string;
    /** Lower numbers appear first in the prizes dialog. */
    overviewListPriority: number;
} & (
    | { kind: "energy" | "beach-coins"; amount: string }
    | { kind: "golden-sunglasses" | "golden-shirt" }
    | { kind: "beach-set" | "angel-set"; bundleSize: HolyWheelBundleSize }
);

type HolyWheelPrizes = readonly [
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
    HolyWheelPrize,
];

// Local presentation only. Index 0 starts just clockwise of the top pointer.
// Amounts are whole-unit decimal strings; this configuration grants no rewards.
// Set bundleSize to select the matching 2–8 piece indicator artwork.
export const HOLY_WHEEL_PRIZES: HolyWheelPrizes = [
    { kind: "angel-set", bundleSize: 3, overviewListPriority: 1 },
    { kind: "beach-set", bundleSize: 2, overviewListPriority: 2 },
    { kind: "beach-coins", amount: "5000000", overviewListPriority: 3 },
    { kind: "golden-shirt", overviewListPriority: 4 },
    { kind: "energy", amount: "250000", overviewListPriority: 5 },
    { kind: "golden-sunglasses", overviewListPriority: 6 },
    { kind: "energy", amount: "5000", overviewListPriority: 7 },
    { kind: "beach-coins", amount: "100000", overviewListPriority: 8 },
    { kind: "energy", amount: "500", overviewListPriority: 9 },
    { kind: "energy", amount: "200", overviewListPriority: 10 },
    { kind: "energy", amount: "100", overviewListPriority: 11 },
    { kind: "energy", amount: "50", overviewListPriority: 12 },
];

export const PRIZE_THUMBNAILS: Record<HolyWheelPrize["kind"], string> = {
    energy,
    "beach-coins": beachCoin,
    "golden-sunglasses": goldenSunglasses,
    "golden-shirt": goldenShirt,
    "beach-set": beachSet,
    "angel-set": angelSet,
};

export const BUNDLE_SIZE_INDICATORS: Record<HolyWheelBundleSize, string> = {
    2: bundleSize2,
    3: bundleSize3,
    4: bundleSize4,
    5: bundleSize5,
    6: bundleSize6,
    7: bundleSize7,
    8: bundleSize8,
};

export type HolyWheelMultiplier = number;

/** A completed local simulation, never an authoritative reward grant. */
export interface HolyWheelPreviewResult {
    id: string;
    prize: HolyWheelPrize;
    multiplier: HolyWheelMultiplier;
}

export const HOLY_WHEEL_MULTIPLIERS: readonly HolyWheelMultiplier[] = [
    1, 2, 3, 5, 7, 10,
];

/** Display total for the local presentation simulation, not a checkout quote. */
export function getHolyWheelSpinPrice(
    unitPriceStars: string | null,
    multiplier: HolyWheelMultiplier,
): string | null {
    if (!unitPriceStars || !/^\d+$/.test(unitPriceStars)) return null;
    return (BigInt(unitPriceStars) * BigInt(multiplier)).toString();
}

export function getHolyWheelPrizeAmount(
    prize: HolyWheelPrize,
    multiplier: HolyWheelMultiplier,
): string | null {
    return "amount" in prize
        ? (BigInt(prize.amount) * BigInt(multiplier)).toString()
        : null;
}

export function getHolyWheelSpinRefund(
    prize: HolyWheelPrize,
    multiplier: HolyWheelMultiplier,
): number {
    return "amount" in prize ? 0 : multiplier - 1;
}
